import initialState from './constants/initialState';
import { emailVerificationActions } from './actionTypes';
import { EmailVerificationState } from 'User/types/emailVerification';
import { Action } from 'shared/store/types';

const defaultState: EmailVerificationState = initialState;

const emailVerification = (
  state = defaultState,
  action: Action
): EmailVerificationState => {
  const { type, payload } = action;
  const { steps } = state;
  const positionOfInterest = payload?.positionOfInterest;
  let stepsOfInterest = steps;
  if (typeof positionOfInterest === 'number' && positionOfInterest >= 0) {
    stepsOfInterest = steps.slice(0, positionOfInterest + 1);
  }

  switch (type) {
    case emailVerificationActions.PUSH:
      return {
        ...state,
        steps: [...stepsOfInterest, payload.stepData],
      };

    case emailVerificationActions.REPLACE: {
      const stepsToConsiderWhileReplace = stepsOfInterest.slice(0, -1);
      return {
        ...state,
        steps: [...stepsToConsiderWhileReplace, payload.stepData],
      };
    }
    default:
      return state;
  }
};

export default emailVerification;
